import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Card, CardBody, CardHeader, Button } from '../components/ui';

export default function PublicProfilePage() {
  const { profileId } = useParams();

  return (
    <div className="grid grid-cols-1 gap-4">
      <Card>
        <CardHeader
          title="Public Profile"
          right={
            <Link to="/discussions">
              <Button variant="secondary">Back</Button>
            </Link>
          }
        />
        <CardBody className="space-y-2">
          <div className="text-sm text-zinc-800">Profile id: {profileId || 'Unknown'}</div>
          <div className="text-sm text-zinc-600">
            Public profile detail is being built. This route is now wired and can be expanded with real profile fields.
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
